<table *ngIf="mostrarTabela; else tabelaSemDados" mat-table [dataSource]="dataSource" style="margin-top: 20px">

    <ng-container matColumnDef="nome">
        <th mat-header-cell *matHeaderCellDef>Nome</th>
        <td mat-cell *matCellDef="let element"> {{element.funcionario.pessoasFisica.nome}} </td>
    </ng-container>

    <ng-container matColumnDef="cargo">
        <th mat-header-cell *matHeaderCellDef> Cargo </th>
        <td mat-cell *matCellDef="let element"> {{element.cargo.nome}} </td>
    </ng-container>

    <ng-container matColumnDef="tipoCargo">
        <th mat-header-cell *matHeaderCellDef> Tipo Cargo </th>
        <td mat-cell *matCellDef="let element"> {{tipoCargo.getDescricao(element.cargo.tipoCargo)}} </td>
    </ng-container>

    <ng-container matColumnDef="acoes">
        <th mat-header-cell *matHeaderCellDef> Ações </th>
        <td mat-cell *matCellDef="let element">
            <button *ngIf="perfilAcesso.deleta" mat-button (click)="deletar(element)">
                <mat-icon matTooltip="excluir">delete</mat-icon>
            </button>
            <button *ngIf="perfilAcesso.consulta" mat-button (click)="atualizar(element)">
                <mat-icon>search</mat-icon>
            </button>
        </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
</table>

<div [hidden]="!mostrarTabela">
    <mat-paginator [pageSizeOptions]="[5]" showFirstLastButtons></mat-paginator>
</div>

<ng-template #tabelaSemDados>
    <div fxLayout="row" fxLayoutAlign="center center" style="padding-top: 10px">
        {{msg}}
    </div>
</ng-template>

<div fxLayout="row" *ngIf="perfilAcesso.insere" fxLayoutAlign="end center" fxLayoutGap="16px" style="padding-top: 30px">
    <div>
        <button matTooltip="Adicionar novo colaborador" mat-fab color="primary" (click)="novo()">
            <mat-icon>add</mat-icon>
        </button>
    </div>
</div>
